import { Link } from 'react-router-dom'
import styled from 'styled-components'

const RouterLink = styled(Link)`
  text-decoration: none;
  color: unset;
`

export default RouterLink
